module.exports = __webpack_public_path__ + "static/media/details-19-image-5.48cab279.jpg";